<button
    class="btn-secondary"
    on:click
    type="button"
>
    <slot/>
</button
>
